export const PRODUCT_IMPORT_SAMPLE_CSV =
  "Name,EAN/UPC,Product Group,Keywords\n" +
  "Pepsi Cola 330ml,5449000000996,Beverages,pepsi cola soft-drink\n" +
  "Lay's Classic 150g,0028400055345,Snacks,lays chips classic\n" +
  "Doritos Nacho Cheese 170g,0028400064545,Snacks,doritos nacho cheese";
